import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MeetingCard = ({ meeting, category, onViewDetails }) => {
  const getTimeRemaining = () => {
    const now = new Date();
    const meetingDateTime = new Date(`${meeting?.meetingDate} ${meeting?.meetingTime}`);
    const timeDiff = meetingDateTime - now;
    const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutesDiff = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

    if (timeDiff < 0) {
      return 'Meeting time passed';
    }

    if (hoursDiff > 24) {
      const days = Math.floor(hoursDiff / 24);
      return `${days} day${days > 1 ? 's' : ''} remaining`;
    }

    if (hoursDiff > 0) {
      return `${hoursDiff}h ${minutesDiff}m remaining`;
    }

    return `${minutesDiff}m remaining`;
  };

  const getStatusColor = () => {
    if (category === 'active') return 'text-success';
    if (category === 'completed') return 'text-muted-foreground';
    return 'text-warning';
  };

  const getStatusIcon = () => {
    if (category === 'active') return 'Navigation';
    if (category === 'completed') return 'CheckCircle';
    return 'Clock';
  };

  return (
    <div className="bg-background rounded-lg border border-border p-4 hover:shadow-md transition-smooth hover-lift">
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="font-heading text-lg font-semibold text-foreground mb-1 line-clamp-1">
            {meeting?.locationName || 'Meeting Location'}
          </h3>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="MapPin" size={14} />
            <span className="line-clamp-1">{meeting?.locationAddress || 'Address not available'}</span>
          </div>
        </div>
        <div className={`flex items-center gap-1 ${getStatusColor()}`}>
          <Icon name={getStatusIcon()} size={16} />
        </div>
      </div>

      {/* Meeting Details */}
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Calendar" size={14} className="text-muted-foreground" />
          <span className="text-foreground">{meeting?.meetingDate || 'Date not set'}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Clock" size={14} className="text-muted-foreground" />
          <span className="text-foreground">{meeting?.meetingTime || 'Time not set'}</span>
        </div>
        {category === 'upcoming' && (
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Timer" size={14} className="text-warning" />
            <span className="text-warning font-medium">{getTimeRemaining()}</span>
          </div>
        )}
      </div>

      {/* Session Code */}
      <div className="mb-4 p-2 bg-muted rounded-md">
        <div className="flex items-center justify-between">
          <span className="text-xs text-muted-foreground">Session Code</span>
          <span className="text-sm font-mono font-semibold text-foreground">
            {meeting?.sessionCode || 'N/A'}
          </span>
        </div>
      </div>

      {/* Action Button */}
      <Button
        variant="outline"
        size="sm"
        fullWidth
        iconName="Eye"
        iconPosition="left"
        onClick={() => onViewDetails?.(meeting?.id)}
      >
        View Details
      </Button>
    </div>
  );
};

export default MeetingCard;